import { SearchParams } from 'jobs.types';

export interface FormData {
  email: string;
  aboName: string;
  query: string;
}

const getAboBody = (formData: FormData, filterData: SearchParams) => {
  const aboBody = {
    email: formData.email,
    name: formData.aboName,
    lang: 'de',
    query: formData.query,
    filters: {},
    sza_filters: {},
  };

  Object.keys(filterData).forEach((key) => {
    if (
      key.match(/^\d+$/) &&
      Array.isArray(filterData[key]) &&
      filterData[key].length > 0
    ) {
      aboBody.filters[key] = filterData[key];
    }
  });

  if (filterData['sza_pensum.min']) {
    aboBody.sza_filters['sza_pensum.max'] = {
      values: filterData['sza_pensum.min'],
      operation: 'ge',
    };
  }

  if (filterData['sza_pensum.max']) {
    aboBody.sza_filters['sza_pensum.min'] = {
      values: filterData['sza_pensum.max'],
      operation: 'le',
    };
  }

  if (Object.keys(aboBody.filters).length === 0) {
    delete aboBody.filters;
  }

  if (Object.keys(aboBody.sza_filters).length === 0) {
    delete aboBody.sza_filters;
  }

  return aboBody;
};

export default getAboBody;
